import React, {useEffect, useState} from "react";
import {
    Card,
    Page,
    Text,
    Layout,
    Button,
    ResourceItem,
    ResourceList,
    Tag, ButtonGroup, Avatar
} from "@shopify/polaris";
import Http from "../Lib/Http";
import {PremadeCharts} from "../types";
import {Redirect} from "@shopify/app-bridge/actions";
import { useGoTo } from '../Lib/useGoTo';
import Alert from "@admin/Lib/Alert";


function PremadeCharts() {
    const [charts, setCharts] = useState<PremadeCharts[]>([]);
    const [selectedChart, setSelectedChart] = useState<string | null>(null);
    const [currentPage, setCurrentPage] = useState(1);
    const goTo = useGoTo();



    useEffect(() => {
        fetchCharts();
    }, []);



    const fetchCharts = () => {

        Http.get(`/app/api/v1/pre-made-charts.json`)
            .then((response) => {
                const data = response.data.charts;
                setCharts(data);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };

    const handleNextPage = () => {
        setCurrentPage(currentPage + 1);
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    const useChart = (id:string) => {
        Http
            .post(`/app/api/v1/pre-made-charts/${id}`)
            .then((res) => {
                Alert.success("Chart cloned successfully.");
                let clonedId = res.data.chart.id;
                goTo('/charts/'+clonedId)
            })
            .catch((e) => {
                Alert.success("Error creating chart");
                console.log(e);
            });
    };


    const goToHelp = () => {
        let redirect = Redirect.create(window.app);
        redirect.dispatch(Redirect.Action.APP, '/app/help');
    };



    const goToBulkHelp = () => {
        let redirect = Redirect.create(window.app);
        redirect.dispatch(Redirect.Action.APP, '/app/bulk-help');
    };




    return (
        <Page title={'Pre-made Charts'}  backAction={{content: 'Home', onAction() {goTo('')  }}}>
                <Layout>
                    <Layout.Section>
                        <Card>
                            <ResourceList
                                resourceName={{singular: 'chart', plural: 'charts'}}
                                items={charts}
                                renderItem={(item) => {
                                    const {id, title, tag, icon} = item;
                                    const tagsArray = tag.split(',').filter(tag => tag.trim() !== '');

                                    return (
                                        <ResourceItem
                                            onClick={() => {
                                                setSelectedChart(id)
                                            }}
                                            id={id}
                                            accessibilityLabel={`View details for ${title}`}
                                            name={title}
                                            media={
                                                <Avatar customer size="xl" name={title} source={icon} />
                                            }
                                        >
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}>
                                                <div>
                                                    <Text variant="headingSm" as="h6">{title}</Text>
                                                    <div className='tag-container'>
                                                        {tagsArray.map((tag, index) => (
                                                            <Tag key={index}>{tag.trim()}</Tag>
                                                        ))}
                                                    </div>
                                                </div>
                                                {selectedChart == id &&
                                                    <div>
                                                        <ButtonGroup>
                                                            {/** <Button>Preview</Button>**/}
                                                            <Button onClick={() => useChart(id)}
                                                                    variant="primary">Use</Button>
                                                        </ButtonGroup>
                                                    </div>
                                                }

                                            </div>

                                        </ResourceItem>
                                    );
                                }}
                            />
                        </Card>
                    </Layout.Section>
                </Layout>
        </Page>
    );
}

export default PremadeCharts;
